import React from 'react'
import { toastr } from 'react-redux-toastr'
import i18next from 'i18next'

import * as TEXTS from 'app/constants/toastrMessages'
import ToastrCheck from 'app/components/SVGS/ToastrCheck'
import ToastrCloseIcon from 'app/components/SVGS/ToastrCloseIcon'
import ToastrWarningIcon from 'app/components/SVGS/ToastrWarningIcon'

export const showSuccess = ({ content, params }) =>
  toastr.success(i18next.t('', params), i18next.t(content, params), { icon: <ToastrCheck /> })

export const showWarning = ({ content }) =>
  toastr.warning(i18next.t(''), i18next.t(content), { icon: <ToastrWarningIcon /> })

export const showInfo = ({ content }) => toastr.info('', i18next.t(content), { icon: <ToastrWarningIcon /> })

export const showError = data => {
  const { content = TEXTS.DEFAULT_ERROR_CONTENT, options } = typeof data === 'object' ? data : {}
  toastr.error(i18next.t(''), i18next.t(content), options, { icon: <ToastrCloseIcon /> })
}

export const showConfirm = ({ title, onOk }) => {
  toastr.confirm(title, {
    disableCancel: true,
    onOk,
    id: 'toastr-confirm-id',
  })
}
